// extracted by mini-css-extract-plugin
export default {"wrapper":"Home_wrapper__Dznmp","header":"Home_header__0XIge","content":"Home_content__SYwYM"};